module.exports = __webpack_public_path__ + "img/usa.14af0d20.svg";